import { motion } from 'framer-motion'
import { Close, HiLoStatsCSS } from './HiLoStatsCSS.styled'
import { useHiLoRankingData } from './useHiLoRankingData'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'

const TABLE_COLUMNS = [
  { id: 0, name: 'Username', width: '1fr', data: 'username' },
  { id: 1, name: 'Streak', width: '1fr', data: 'Streaks' },
  { id: 2, name: 'Rank', width: '0.5fr', data: 'rank' },
]

const gridColumns = TABLE_COLUMNS.reduce((array, item) => [...array, item.width], []).join(' ')
export const HiLoStats = ({ layoutId, onClose }) => {
  const { rankingData } = useHiLoRankingData()

  return (
    <HiLoStatsCSS gridColumns={gridColumns}>
      <motion.div layoutId={layoutId} className='overlay'>
        <Close masking onClick={onClose} />
        <div className='table-wrapper'>
          <div className='table-body'>
            {/* HEADER */}
            {TABLE_COLUMNS.map((column, index) => {
              return <div className='table-cell-header'>{column.name}</div>
            })}
            {rankingData.map((row, idx) => (
              <>
                {/* ROW */}
                <div className='table-cell-data'>{row.username}</div>
                <div className='table-cell-data'>{row.dailyHighestWinStreak}</div>
                <div className='table-cell-data'>
                  <ContentSwitcherByState
                    activeState={idx}
                    stateObject={{
                      0: '🥇',
                      1: '🥈',
                      2: '🥉',
                      default: '',
                    }}
                  />
                </div>
              </>
            ))}
          </div>
        </div>
      </motion.div>
    </HiLoStatsCSS>
  )
}
